<p-toast></p-toast>

<p-sidebar [(visible)]="visibleSidebarRiderVehicleDetail"
           [position]="'right'"
           [baseZIndex]="10000"
           (onHide)="cancel()"
           [style]="{width:'900px'}">

    <p-dialog [(visible)]="isVisibleImageModal" *ngIf="isVisibleImageModal" [modal]="true" [style]="{ width: '50vw' }" [draggable]="false" [resizable]="false">
        <p-carousel [value]="imageArray" [numVisible]="1" [numScroll]="1" verticalViewPortHeight="360px">
            <ng-template let-image pTemplate="item">
                <div class="mb-3">
                    <img src="{{ image }}" class="document-image" />
                </div>
            </ng-template>
        </p-carousel>
    </p-dialog>

    <ng-template pTemplate="header">
        <div class="flex flex-row sidebar-head" *ngIf="riderVehicleInfo">
            <div class="sidebar-head__rider-img">
                <img src="{{riderVehicleInfo.ImageUrl}}" />
            </div>
            <div class="sidebar-head__info-rider">
                <div class="sidebar-head__rider-name">{{riderVehicleInfo.UserName}} <span class="sbh-rider-vehicle-status" *ngIf="riderVehicleInfo.IsOwner">Owned</span> <span class="sbh-rider-vehicle-status" *ngIf="!riderVehicleInfo.IsOwner">Not Owned</span></div>
                <div class="flex flex-row sidebar-head__sub-block">
                    <div class="sidebar-head__sub-title">Service: <span class="sbh-sub-title-value">{{riderVehicleInfo.VehicleTypeText}}</span></div>
                    <div class="sidebar-head__sub-title">Last Update: <span class="sbh-sub-title-value">{{riderVehicleInfo.LastUpdate}}</span></div>
                </div>
            </div>
        </div>
    </ng-template>

    <div *ngIf="loading" style="text-align: center;">
        <p-progressSpinner [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner" strokeWidth="5" fill="var(--surface-ground)" animationDuration="1s"></p-progressSpinner>
    </div>

    <p-scrollPanel [style]="{width:'100%', height: 'calc(100vh - 120px)'}"
                   [styleClass]="'app-scrollpanel'" *ngIf="!loading && riderVehicleInfo">
        <div class="rider-info-body">
            <div class="flex flex-row">
                <div class="rider-info-img">
                    <img src="{{riderVehicleInfo.ImageUrl}}" />
                </div>
                <div class="w-70">
                    <div class="flex flex-row">
                        <div class="rider-column-30">
                            <div class="rider-label">Full Name</div>
                        </div>
                        <div class="rider-column-70">
                            <div class="rider-text">{{riderVehicleInfo.UserName}}</div>
                        </div>
                    </div>
                    <div class="flex flex-row">
                        <div class="rider-column-30">
                            <div class="rider-label">Gender</div>
                        </div>
                        <div class="rider-column-70">
                            <div class="rider-text">{{riderVehicleInfo.Gender}}</div>
                        </div>
                    </div>
                    <div class="flex flex-row">
                        <div class="rider-column-30">
                            <div class="rider-label">Phone</div>
                        </div>
                        <div class="rider-column-70">
                            <div class="rider-text">{{riderVehicleInfo.Phone}}</div>
                        </div>
                    </div>
                    <div class="flex flex-row">
                        <div class="rider-column-30">
                            <div class="rider-label">Email</div>
                        </div>
                        <div class="rider-column-70">
                            <div class="rider-text">{{riderVehicleInfo.Email}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="oi-menu">
            <p-tabMenu [model]="menuItems" [scrollable]="true" [activeItem]="menuItems[0]"></p-tabMenu>
        </div>

        <div *ngIf="activeTab === menuTab.VehicleDetails">
            <div class="oi-menu-body">
                <div class="flex flex-row vd-body">
                    <div class="vd-column w-40">
                        <img class="vd-img" src="{{riderVehicleInfo.VehicleFrontImageUrl}}"
                             (click)="showVisibleImageModal([riderVehicleInfo.VehicleFrontImageUrl])" />
                    </div>
                    <div class="vd-column w-60">
                        <div class="td-title">{{riderVehicleInfo.VehicleModel}} {{riderVehicleInfo.VehicleModelSeries}} {{riderVehicleInfo.NumberPlate}}</div>
                        <div class="flex flex-row">
                            <div class="td-col-40 td-label">Date: </div>
                            <div class="td-col-60 td-value">{{riderVehicleInfo.CreateAtText}}</div>
                        </div>
                        <div class="flex flex-row">
                            <div class="td-col-40 td-label">Time: </div>
                            <div class="td-col-60 td-value">{{riderVehicleInfo.TimeText}}</div>
                        </div>
                        <div class="flex flex-row">
                            <div class="td-col-40 td-label">Assessor: </div>
                            <div class="td-col-60 td-value">{{riderVehicleInfo.AssesorUserName}}</div>
                        </div>
                        <div class="flex flex-row">
                            <div class="td-col-40 td-label">Confirmed: </div>
                            <div class="td-col-60 td-value">{{riderVehicleInfo.ConfirmedText}}</div>
                        </div>
                        <div class="td-line"></div>
                        <div>
                            <div class="flex flex-row vd-status" *ngIf="riderVehicleInfo.VehicleStatusId === vehicleStatusEnum.Approved">
                                <div class="td-col-40 td-label">Status: </div>
                                <div class="td-col-60"><span class="oi-result-approved">Approved</span></div>
                            </div>
                            <div class="flex flex-row vd-status" *ngIf="riderVehicleInfo.VehicleStatusId === vehicleStatusEnum.Rejected">
                                <div class="td-col-20 td-label">Status: </div>
                                <div class="td-col-30"><span class="oi-result-rejected">Rejected</span></div>
                                <div class="td-col-20 td-label">Reason: </div>
                                <div class="td-col-30"><span class="oi-result-reason">{{riderVehicleInfo.RejectReason}}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div *ngIf="activeTab === menuTab.VehicleRequirements">
            <div class="oi-menu-body">
                <div class="rider-text">No vehicle requirement documents available.</div>
            </div>
        </div>

        <div *ngIf="activeTab === menuTab.TNCRequirements">
            <div class="oi-menu-body">
                <div class="rider-text">No TNC requirement documents available.</div>
            </div>
        </div>
    </p-scrollPanel>

</p-sidebar>